<template>
    <div class="mt-24 sm:mt-28 mx-3 sm:mx-4 bg-skin-b-list-head border border-skin-b-list-bord shadow rounded-t-lg">
        <IconAdmin 
        v-if="admin"
        class="float-left w-8 h-8 ml-4 my-2"
        />
        <h4 class="px-4 py-2 text-skin-b-list-base font-bold text-xl sm:text-2xl text-center leading-tight truncate">
            <slot></slot>
        </h4> 
    </div>
</template>
<script>
import IconAdmin from '../icons/IconAdmin.vue'

export default {
    components: {
        IconAdmin,
    },
    props: {
        admin: {
        type: Boolean,
        default: false
      },
    },
  };
</script>
<style scoped>
</style>